import { useUnsyncHold } from "#webapp/src/components/hooks/useUnsyncHold";
import { track, TrackingEvents } from "#webapp/src/util/analytics.util";
import { logger } from "@clockwise/client-commons/src/util/logger";
import { Button } from "@clockwise/design-system";
import { Delete } from "@clockwise/design-system/icons";
import React from "react";
import toast from "react-hot-toast";

export type RemoveHoldContainerProps = {
  holdId: string;
  orgId: string;
};

const RemoveHoldContainer = ({ holdId, orgId }: RemoveHoldContainerProps) => {
  const [onUnsyncHold] = useUnsyncHold({
    input: { orgId, holdId },
    onError: (error) => {
      logger.error("Unable to unsync hold", error);
      toast.error("Sorry, there was a problem removing your hold.");
    },
    onCompleted: (data) => {
      if (data.unsyncHold?.success) {
        track(TrackingEvents.SMART_HOLD.UNSYNCED, { eventId: holdId, surface: "Sidepanel " });
      }
    },
  });

  return (
    <div className="cw-mt-2 -cw-ml-[11px]">
      <Button onClick={onUnsyncHold} variant="text" startIcon={Delete} sentiment="neutral">
        <div className="cw-ml-[6px]">Remove this hold</div>
      </Button>
    </div>
  );
};

export default RemoveHoldContainer;
